import styled from '@emotion/styled';
import { StyledProps } from './TableRowContainer.types';

export default styled.tr<StyledProps>`
  liststyletype: none;
  background-color: ${(props) => props.primaryColor};
  color: ${(props) => props.color || 'black'};

  &:nth-of-type(2n + 1) {
    border: 1px var(--color-smoke-30);
    border-style: solid;
  }

  &:nth-of-type(2n) {
    background-color: ${(props) => props.secondaryColor || 'var(--color-putty-50)'};
    border: 1px var(--color-smoke-30);
    border-style: solid;
  }

  &:hover {
    background-color: ${(props) => props.rowClickable && 'var(--color-putty)'};
    cursor: pointer;
  }
`;
